module.exports = __webpack_public_path__ + "static/img/ios.aa238dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/ios.png
// module id = cyxK
// module chunks = 1